import type { ConfigRequest } from '@pba/react-utils';
import type { components } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

export type GetUsersParams = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  cursor?: string;
  exclude_community_id?: string;
  exclude_program_id?: string;
  limit?: number;
  scope: 'all';
  search?: string;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const getUsers = async ({ config }: ConfigRequest<GetUsersParams>) =>
  apiClient.get<Array<components['schemas']['UserList']>, ApiClientResponse<Array<components['schemas']['UserList']>>>(
    routes.user.autocomplete,
    config,
  );
